export default __webpack_public_path__ + "static/media/ico_vk.85da9ca9.png";